<template>
  <div style="display: inline-block">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          color="orange darken-2" 
          fab 
          x-small 
          dark 
          v-bind="attrs" 
          v-on="on"
          @click="openDialog"
          elevation="2"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <span style="font-family: 'Cairo', sans-serif">تعديل قناة القبول</span>
    </v-tooltip>

    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card elevation="8" style="direction: rtl; font-family: 'Cairo', sans-serif">
        <v-card-title style="background-color: #ff9800; color: white; text-align: center">
          <v-spacer></v-spacer>
          <span class="text-h5" style="font-family: 'Cairo', sans-serif; font-weight: bold">تعديل قناة القبول</span>
          <v-spacer></v-spacer>
        </v-card-title>
        
        <v-card-text style="padding: 24px">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="selectedAcceptedType"
                  :items="acceptedTypes"
                  item-text="acceptedName"
                  item-value="idAcceptedType"
                  label="قناة القبول"
                  :rules="[v => !!v || 'حقل مطلوب']"
                  required
                  outlined
                  style="font-family: 'Cairo', sans-serif"
                  color="orange darken-2"
                  item-color="orange darken-2"
                ></v-select>
              </v-col>
              
              <v-col cols="6">
                <v-text-field
                  v-model="studentLevel"
                  label="المرحلة"
                  readonly
                  outlined
                  style="font-family: 'Cairo', sans-serif"
                  color="orange darken-2"
                ></v-text-field>
              </v-col>
              
              <v-col cols="6">
                <v-text-field
                  v-model="academicYear"
                  label="السنة الدراسية"
                  readonly
                  outlined
                  style="font-family: 'Cairo', sans-serif"
                  color="orange darken-2"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        
        <v-card-actions style="padding: 16px 24px; direction: rtl">
          <v-btn 
            color="orange darken-2" 
            depressed
            @click="updateAcceptedChannel"
            :loading="loading"
            :disabled="!selectedAcceptedType"
            style="font-family: 'Cairo', sans-serif; font-weight: bold; color: white; margin-left: 12px"
          >
            تحديث
          </v-btn>
          <v-btn 
            color="grey" 
            text 
            @click="dialog = false"
            style="font-family: 'Cairo', sans-serif"
          >
            إلغاء
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'EditStudentAcceptedChannel',
  props: {
    studentId: {
      type: Number,
      required: true
    },
    studentLevel: {
      type: Number,
      required: true
    },
    yearStudyId: {
      type: Number,
      required: true
    },
    academicYear: {
      type: String,
      required: true
    },
    currentChannel: {
      type: Object,
      required: true
    },
    acceptedTypes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      selectedAcceptedType: null
    }
  },
  methods: {
    openDialog() {
      this.selectedAcceptedType = this.currentChannel.acceptTypeId || null;
      this.dialog = true;
    },
    
    updateAcceptedChannel() {
      if (!this.selectedAcceptedType) {
        this.$toasted.error("يرجى اختيار قناة القبول");
        return;
      }

      this.loading = true;
      
      const data = {
        studentId: this.studentId,
        acceptTypeId: this.selectedAcceptedType,
        studentLevel: this.studentLevel,
        yearStudyId: this.yearStudyId
      };

      this.$http.put(`${this.$store.state.apiUrlRegistration}/studentAcceptedChannel/${this.currentChannel.idStudentAcceptedChannel}`, data, {
        headers: { Authorization: `Bearer ${this.$store.state.user}` }
      }).then((response) => {
        console.log('Channel updated successfully:', response);
        this.$toasted.success("تم تحديث قناة القبول بنجاح");
        this.dialog = false;
        this.$emit('reloadTask');
      }).catch((error) => {
        console.log('Error updating channel:', error);
        this.$toasted.error("خطأ في تحديث قناة القبول");
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>
</style>
